import React from 'react';
import { Navigate } from 'react-router-dom';
import { isEmpty } from 'lodash/lang';

import { withAppInfo } from '../../../common/hocs/withAppInfo';
import NotificationManager from '../../../common/notifications/NotificationManager';
import { UNAUTHORIZED_ACCESS } from '../../../constants/notificationMessages';
import { useCurrentUser } from '../Container/CurrentUserContainer';

export function withAuthorizedAccess(access, Component) {
  function WrapperComponent(props) {
    const { accessToPages } = useCurrentUser();
    if (!accessAllowed(access, accessToPages)) {
      setTimeout(function() {
        NotificationManager.error(UNAUTHORIZED_ACCESS);
      }, 50);
      return <Navigate to="/" replace />;
    }
    return <Component {...props} />;
  }

  return WrapperComponent;
}

export function withFeatureFlag(feature, Component) {
  function WrapperComponent({ appInfo, ...props }) {
    if (!featureEnabled(feature, appInfo?.features)) {
      return <Navigate to="/" replace />;
    }
    return <Component {...props} />;
  }

  return withAppInfo(WrapperComponent);
}

export function accessAllowed(access, accessToPages) {
  if (isEmpty(accessToPages) || isEmpty(access)) {
    return false;
  }
  return access.every(v => accessToPages.includes(v));
}

function featureEnabled(feature, featureMap) {
  return !feature ? true : Boolean(featureMap && featureMap[feature]);
}
